
import { defineComponent } from 'vue'
import type { V2PlanConfig } from './v2PlanConfig'
import { ENTERPRISE_PLAN } from './v2PlanConfig'

export default defineComponent({
  name: 'V2ActiveEnterprisePlanCard',
  props: {
    name: {
      type: String,
      required: true
    },
    price: {
      type: String,
      required: true
    },
    contributors: {
      type: Number,
      default: 0
    },
    ossTargets: {
      type: Number,
      default: 0
    },
    aiCreditBalance: {
      type: Number,
      default: 0
    },
    nextRenewal: {
      type: String,
      default: ''
    },
    billingInterval: {
      type: String,
      default: 'Yearly'
    }
  },
  data() {
    return {
      showIncluded: false
    }
  },
  computed: {
    planConfig(): V2PlanConfig {
      return ENTERPRISE_PLAN
    },
    formattedCreditBalance(): string {
      return `$${this.aiCreditBalance.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`
    },
    usageRoute(): string {
      return this.$generateRoute(['settings', 'usage'], false, true)
    }
  }
})
